// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__95DqB","rootCenter":"LoadMoreObserver_rootCenter__aqkf1","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__KMnWj"};